// On the "Per Mail versenden" screen: clicking a suggested address appends it to the "An" field.
up.compiler('.invoice-mailing-recipient-suggestion', (link) => {
  link.addEventListener('click', (event) => {
    event.preventDefault()

    const input = document.querySelector('.invoice-mailing-recipients-field')
    if (!input) return

    const address = link.dataset.address
    const addresses = input.value.split(/[,;\s]+/).filter((value) => value.length > 0)
    if (!addresses.includes(address)) {
      addresses.push(address)
    }
    input.value = addresses.join(', ')
    input.dispatchEvent(new Event('input', { bubbles: true }))
  })
})
